import React from "react";
import DSBox from "../../system-design/DSBox";
import DSIconButton from "../../system-design/DSIconButton";
import DSTypography from "../../system-design/DSTypography";
import { NavigateBefore, NavigateNext } from "@mui/icons-material";

type CalendarNavigationProps = {
  currentDate: Date;
  onNavigate: (direction: "prev" | "next") => void;
};

const CalendarNavigation = ({
  currentDate,
  onNavigate,
}: CalendarNavigationProps) => {
  const formatMonth = (date: Date) => {
    return date.toLocaleDateString("en-US", {
      month: "long",
      year: "numeric",
    });
  };

  return (
    <DSBox sx={{ display: "flex", alignItems: "center", mb: 2 }}>
      <DSIconButton
        onClick={() => onNavigate("prev")}
        aria-label="Previous month"
      >
        <NavigateBefore />
      </DSIconButton>
      <DSTypography
        variant="h6"
        sx={{ mx: 2, minWidth: 200, textAlign: "center" }}
      >
        {formatMonth(currentDate)}
      </DSTypography>
      <DSIconButton onClick={() => onNavigate("next")} aria-label="Next month">
        <NavigateNext />
      </DSIconButton>
    </DSBox>
  );
};

export default CalendarNavigation;
